export default "__VITE_ASSET__04ea2eec__"